// extracted by mini-css-extract-plugin
module.exports = {"TimePeriod":"TimePeriod--1atLB","NoIcon":"NoIcon--3rsVk"};